import { areWeOpenForBusiness } from 'utils/OpenHoursHelper'
import { HOURS_AVAILABILITY_MODES } from 'app/modules/teams/constants'
import { get } from 'lodash'


const teamIsCurrentlyAvailable = (timezone, openHours) => {
    return timezone && openHours && areWeOpenForBusiness(timezone, openHours)
}

export const isTeamOnline = ( activeCount, autoOffline, team, teamAvailability) => {
    const timezone = get(teamAvailability, 'timezone', '')
    const openHours = get(teamAvailability, 'openHours', '')
    if(autoOffline && activeCount === 0){
      return false
    }
    else{
      return team.teamAvailabilityMode === HOURS_AVAILABILITY_MODES.ALWAYS_ONLINE || (team.teamAvailabilityMode === HOURS_AVAILABILITY_MODES.CUSTOM_HOURS && teamIsCurrentlyAvailable(timezone, openHours))
    }
}



// WEBPACK FOOTER //
// ./src/scripts/utils/TeamOnlineStatusHelper.js